import styled from '@emotion/styled';

// Global form row grid
export const FormFieldsInputGrid = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: flex-start;
`;
